import React from 'react';
import {connect} from 'react-redux';
import {GeneralContent} from '../Redux/ContentfulContentGrabber';
import '../CSS/App.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class FooterComponent extends React.Component {

    componentWillMount() {
        this.props.fetchData();
    }

    //Checks to see if contentful content has returned data yet
    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.generalContent);
    }

    render() {
        let footerHTML = [];
        if (this.isContentfulContentAvailableYet()) {
            let contactSupportMessage = this.props.generalContent.items[0].fields.contactSupport;
            footerHTML.push(
                <div>
                    <div className="footer">
                        <div className={"footerText"}>
                            <p className="fontRegularSmall">{contactSupportMessage},&nbsp;
                                <a className="contactSupport" href='mailto:support@freshii.com?subject=System Status - Issue Report'> Contact Support</a>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            //React CSS Transition Group causes the component to fade in
            <ReactCSSTransitionGroup
                transitionName="example"
                transitionAppear={true}
                transitionAppearTimeout={50000}
                transitionEnter={false}
                transitionLeave={false}>
                <div className={"footerComponent"}>{footerHTML}</div>
            </ReactCSSTransitionGroup>
        );
    }
}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        generalContent: state.generalContent,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(GeneralContent())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterComponent);



// WEBPACK FOOTER //
// ./src/Components/FooterComponent.js